<template>
  <Toast/>
  <DialogConfirmation ref="dialogConfirmation"/>
  <DataTable
      class="p-datatable-sm"
      :value="sites"
      :resizableColumns="true"
      columnResizeMode="fit"
      sortField="cle"
      :sortOrder="-1"
      :reorderableColumns="true"
      selectionMode="single"
      dataKey="cle"
      :paginator="true"
      :rows="10"
      paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
      :rowsPerPageOptions="[10, 30, 100]"
      currentPageReportTemplate="Afficher {first} de {last} sur {totalRecords} sites"
  >
    <template #empty>
      <div v-if="isRechercheDataLoading == true" class="row">
        <div class="col">
          <vue-loaders name="ball-beat" class="justify-center"></vue-loaders>
        </div>
      </div>
      <div v-else class="row">
        &nbsp;&nbsp;&nbsp;Aucun enregistrement retourné
      </div>
    </template>
    <Column
        field="cle"
        header="Clé"
        :sortable="true"
    ></Column>
    <Column field="entite" header="Entité" :sortable="true">
      <template #body="{ data, field }">
        <div class="row">
          <div class="col">
            <Dropdown class="dropdown-height"
                      v-model="data[field]"
                      :options="entiteLibelles"
                      optionValue="valeur"
                      optionLabel="texte"
                      scrollHeight="205px"
                      :showClear="true"/>
          </div>
        </div>
      </template>
    </Column>
    <Column
        field="abbreviation"
        header="Abbréviation"
        :sortable="true"
    >
      <template #body="{ data, field }">
        <div class="row">
          <div class="col">
            <InputText v-model="data[field]"/>
          </div>
        </div>
      </template>
    </Column>
    <Column
        field="description"
        header="Nom"
        :sortable="true"
    >
      <template #body="{ data, field }">
        <div class="row">
          <div class="col">
            <InputText v-model="data[field]"/>
          </div>
        </div>
      </template>
    </Column>
    <Column
        field="creerPar"
        header="Créer Par"
        :sortable="true"
    ></Column>
    <Column
        field="creerLe"
        header="Créer Le"
        :sortable="true"
    >
      <template #body="slotProps">
        {{
          $commun.formatDateHeure(
              slotProps.data.creerLe
          )
        }}
      </template>
    </Column>
    <Column
        field="modifiePar"
        header="Modifier Par"
        :sortable="true"
    ></Column>
    <Column
        field="modifieLe"
        header="Modifier Le"
        :sortable="true"
    >
      <template #body="slotProps">
        {{
          $commun.formatDateHeure(
              slotProps.data.modifieLe
          )
        }}
      </template>
    </Column>
    <Column
        field="numeroSequence"
        header="Numero Série"
        :sortable="true"
    >
      <template #body="{ data, field }">
        <div class="row">
          <div class="col">
            <InputNumber v-model="data[field]"/>
          </div>
        </div>
      </template>
    </Column>
    <Column field="dateSequence" header="Date" :sortable="true">
      <template #body="{ data, field }">
        <div class="row">
          <div class="col">
            <InputText v-model="data[field]" type="datetime-local"/>
          </div>
        </div>
      </template>
    </Column>
    <Column
        field="siteOrigine"
        header="Sites d'origine "
        :sortable="true"
    >
      <template #body="{ data, field }">
        <div class="row">
          <div class="col">
            <InputText v-model="data[field]"/>
          </div>
        </div>
      </template>
    </Column>
    <Column
        field="siteApplicable"
        header="Sites Applicables"
        :sortable="true"
    >
      <template #body="{ data, field }">
        <div class="row">
          <div class="col">
            <InputText v-model="data[field]"/>
          </div>
        </div>
      </template>
    </Column>
    <Column
        field="heureDebut"
        header="Heure"
        :sortable="true"
    >
      <template #body="{ data, field }">
        <div class="row">
          <div class="col">
            <InputText v-model="data[field]"/>
          </div>
        </div>
      </template>
    </Column>
    <Column headerStyle="width: 8rem" :exportable="false">
      <template #body="slotProps">
        <div class="row">
          <div class="col">
            <Button
                icon="pi pi-save"
                class="p-button-datatable p-button-rounded-sm"
                @click="sauvegarder(slotProps.data)"
            />
          </div>
          <div class="col">
            <Button
                icon="pi pi-trash"
                class="p-button-datatable p-button-rounded-sm"
                @click="confirmerSuppression(slotProps.data)"
            />
          </div>
        </div>
      </template>
    </Column>
  </DataTable>
</template>

<script>

import DialogConfirmation from '../../Commun/DialogConfirmation.vue';

export default {
  name: "ResultatSites",
  emits: ['removeSiteFromList'],
  props: ['entiteLibelles', 'sites', 'isRechercheDataLoading'],
  components: {
    DialogConfirmation
  },
  data() {
    return {siteToDelete: {}}
  },
  methods: {
    confirmerSuppression(data) {
      this.siteToDelete = data;
      this.$confirm.require({
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        message: "Voulez-vous supprimer ce site?",
        accept: () => {
          return this.supprimer();
        },
        reject: () => {
        },
      })
    },
    supprimer() {
      this.$store.dispatch('pilotage/supprimerSiteAction', {siteVO: this.siteToDelete})
          .then((res) => {
            if (res?.data?.messageVOs.length == 0) {
              this.$toast.add({
                severity: 'success',
                summary: 'Suppression Site',
                detail: "La suppression a été effectuée",
                life: 6000
              });
              this.$emit("removeSiteFromList", this.siteToDelete.cle);
            } else {
              this.$root.$refs.messagesComp.messagesList = res.data.messageVOs;
            }
          });
    },
    sauvegarder(data) {
      this.$store.dispatch('pilotage/modifierSiteAction', {siteVO: data}).then(() => {
        this.$toast.add({
          severity: 'success',
          summary: 'Modification Site',
          detail: 'La modification a été effectuée',
          life: 6000
        });
      });
    },
  },
}
</script>

<style scoped>

</style>